var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
import { FilterService } from '~/utils/filter.service';
var CaseRepaymentService = /** @class */ (function () {
    function CaseRepaymentService() {
    }
    /**
     * 新增还款记录
     */
    CaseRepaymentService.prototype.addCaseRepayment = function (data) {
        return this.netService.send({
            server: domainService.caseRepaymentController.addCaseRepayment,
            data: {
                caseId: data.id,
                repayAmount: data.repaymentAmount
            }
        });
    };
    /**
     * 新增还款记录批量
     */
    CaseRepaymentService.prototype.addCaseRepaymentBatch = function (data) {
        return this.netService.send({
            server: domainService.caseRepaymentController.addCaseRepaymentBatch,
            data: {
                caseRepaymentRequests: data
            }
        });
    };
    /**
     * 还款记录查询
     */
    CaseRepaymentService.prototype.selectCaseRepayment = function (data, page) {
        return this.netService.send({
            server: domainService.caseRepaymentController.selectCaseRepayment,
            data: {
                caseNumber: data.caseNumber,
                caseRepaymentMethod: data.caseRepaymentMethod,
                entryTimeMin: FilterService.dateRanageFormat(data.createTime).start,
                entryTimeMax: FilterService.dateRanageFormat(data.createTime).end,
                idCard: data.idCard,
                mobileNo: data.mobileNo,
                name: data.name,
                personalName: data.personalName,
                caseId: data.caseId,
                repayAmountMin: data.repayAmount ? data.repayAmount.min : '',
                repayAmountMax: data.repayAmount ? data.repayAmount.max : '',
                repaymentAcctname: data.repaymentAcctname,
                repaymentAcctno: data.repaymentAcctno,
                collectorRealName: data.collectorRealName,
                deptName: data.deptName
            },
            page: page
        });
    };
    /**
     * 导出还款记录
     */
    CaseRepaymentService.prototype.exportCaseRepayment = function (data) {
        return this.netService.send({
            server: domainService.caseRepaymentController.exportCaseRepayment,
            data: {
                caseNumber: data.caseNumber,
                caseRepaymentMethod: data.caseRepaymentMethod,
                entryTimeMin: FilterService.dateRanageFormat(data.createTime).start,
                entryTimeMax: FilterService.dateRanageFormat(data.createTime).end,
                idCard: data.idCard,
                mobileNo: data.mobileNo,
                name: data.name,
                personalName: data.personalName,
                caseId: data.caseId,
                repayAmountMin: data.repayAmount ? data.repayAmount.min : '',
                repayAmountMax: data.repayAmount ? data.repayAmount.max : '',
                repaymentAcctname: data.repaymentAcctname,
                repaymentAcctno: data.repaymentAcctno,
                collectorRealName: data.collectorRealName,
                deptName: data.deptName
            }
        });
    };
    /**
     * 还款总金额统计
     */
    CaseRepaymentService.prototype.caseRepaymentAmount = function (data) {
        return this.netService.send({
            server: domainService.caseRepaymentController.caseRepaymentAmount,
            data: {
                caseNumber: data.caseNumber,
                caseRepaymentMethod: data.caseRepaymentMethod,
                entryTimeMin: FilterService.dateRanageFormat(data.createTime).start,
                entryTimeMax: FilterService.dateRanageFormat(data.createTime).end,
                idCard: data.idCard,
                mobileNo: data.mobileNo,
                name: data.name,
                personalName: data.personalName,
                caseId: data.caseId,
                repayAmountMin: data.repayAmount ? data.repayAmount.min : '',
                repayAmountMax: data.repayAmount ? data.repayAmount.max : '',
                repaymentAcctname: data.repaymentAcctname,
                repaymentAcctno: data.repaymentAcctno,
                collectorRealName: data.collectorRealName,
                deptName: data.deptName
            }
        });
    };
    /**
     * 新增还款申请
     */
    CaseRepaymentService.prototype.addCaseRepaymentApply = function (data) {
        return this.netService.send({
            server: domainService.caseRepaymentController.addCaseRepaymentApply,
            data: data
        });
    };
    /**
     * 获取收款账户
     */
    CaseRepaymentService.prototype.getReceiveAccount = function (paymentType, caseTaskId) {
        return this.netService.send({
            server: domainService.caseRepaymentController.getReceiveAccount,
            data: { paymentType: paymentType, caseTaskId: caseTaskId }
        });
    };
    /**
     * 回款列表
     */
    CaseRepaymentService.prototype.getAllPaymentConfirmationList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseRepaymentController.getAllPaymentConfirmationList,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 回款确认
     */
    CaseRepaymentService.prototype.confirmCaseRepaymentApply = function (data) {
        return this.netService.send({
            server: domainService.caseRepaymentController.confirmCaseRepaymentApply,
            data: data
        });
    };
    /**
     * 报表管理-回款明细报表
     */
    CaseRepaymentService.prototype.getCaseRepaymentDetailReport = function (data, page) {
        return this.netService.send({
            server: domainService.caseRepaymentController.getCaseRepaymentDetailReport,
            data: data,
            page: page
        });
    };
    /**
     * 报表管理-佣金报表
     */
    CaseRepaymentService.prototype.getCommissionReport = function (data, page) {
        return this.netService.send({
            server: domainService.caseRepaymentController.getCommissionReport,
            data: data,
            page: page
        });
    };
    /**
     * 报表管理-佣金报表金额统计
     */
    CaseRepaymentService.prototype.getCommissionReportAmount = function (data) {
        return this.netService.send({
            server: domainService.caseRepaymentController.getCommissionReportAmount,
            data: data
        });
    };
    /**
     * 报表管理-绩效报表
     */
    CaseRepaymentService.prototype.getPerformanceReport = function (data, page) {
        return this.netService.send({
            server: domainService.caseRepaymentController.getPerformanceReport,
            data: data,
            page: page
        });
    };
    /**
     * 报表管理-绩效报表金额统计
     */
    CaseRepaymentService.prototype.getPerformanceReportAmount = function (data) {
        return this.netService.send({
            server: domainService.caseRepaymentController.getPerformanceReportAmount,
            data: data
        });
    };
    /**
     * 绩效报表导出
     */
    CaseRepaymentService.prototype.performanceReportExport = function (data) {
        return this.netService.send({
            server: domainService.caseRepaymentController.performanceReportExport,
            data: data
        });
    };
    /**
     * 佣金报表导出
     */
    CaseRepaymentService.prototype.commissionReportExport = function (data) {
        return this.netService.send({
            server: domainService.caseRepaymentController.commissionReportExport,
            data: data
        });
    };
    /**
     * 回款明细报表导出
     */
    CaseRepaymentService.prototype.caseRepaymentDetaiReportExport = function (data) {
        return this.netService.send({
            server: domainService.caseRepaymentController.caseRepaymentDetaiReportExport,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseRepaymentService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], CaseRepaymentService.prototype, "addCaseRepaymentBatch", null);
    __decorate([
        Debounce()
    ], CaseRepaymentService.prototype, "selectCaseRepayment", null);
    __decorate([
        Debounce()
    ], CaseRepaymentService.prototype, "exportCaseRepayment", null);
    __decorate([
        Debounce()
    ], CaseRepaymentService.prototype, "caseRepaymentAmount", null);
    __decorate([
        Debounce()
    ], CaseRepaymentService.prototype, "addCaseRepaymentApply", null);
    __decorate([
        Debounce()
    ], CaseRepaymentService.prototype, "getReceiveAccount", null);
    return CaseRepaymentService;
}());
export { CaseRepaymentService };
